<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        small
        >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat tile class="flex-grow-0">
        <v-toolbar-title class="title">
          <span>{{ $t('gameSettings') }}</span>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="form" v-model="validForm">
        <v-card-text>
          <div class="pl-6">
            <v-row
              class="ml-0"
              align="center"
              justify="start"
              v-if="loading"
              >
              <div
                class="imgLoader"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                  color="primary"
                ></v-progress-circular>
              </div>
            </v-row>
            <v-img
              v-else
              width="50%"
              class="mt-3 mb-9"
              :src="srcImg"
            ></v-img>
          </div>
          <div
            class="px-6"
          >
            <v-text-field
              v-model="gameName"
              :label="$t('name')"
              class="mb-4"
              outlined
              hide-details
              dense
              :loading="loading"
              disabled
            ></v-text-field>
          </div>

          <div class="pa-4 px-6">
            <v-select
              v-model="categoriesSelected"
              :items="categoriesByGame"
              label="Categorias"
              item-text="name"
              item-value="id"
              outlined
              dense
              :loading="loading"
              hide-details="auto"
              :menu-props="{ bottom: true, offsetY: true }"
              multiple
            >
              <template v-slot:selection="{ item }">
                <v-chip class="my-2">
                  <v-icon
                    :color="handleColorStatus(item.status)"
                    x-small
                    left
                  >
                    mdi-circle
                  </v-icon>
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ active, item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-row no-gutters align="center">
                        <v-icon
                          :color="handleColorStatus(item.status)"
                          x-small
                          left
                        >
                          mdi-circle
                        </v-icon>
                      <span>{{ item.name }}</span>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions
          class="d-flex flex-wrap pa-4"
        >
          <v-row no-gutters :class="$vuetify.breakpoint.xs ? 'd-flex flex-column' : ''">
            <v-col
              xs="12"
              class="d-flex justify-end"
              :order="$vuetify.breakpoint.xs ? 'first' : ''"
            >
              <v-spacer></v-spacer>
              <v-btn
                class="mr-4 white black--text"
                style="border-color: #2196F3"
                :disabled="loading"
                @click.prevent="dialog = false"
                >
                {{ $t("toCancel") }}
              </v-btn>

              <v-btn
                class="info"
                type="submit"
                @click.prevent="bindGameToCategories()"
                :loading="loading"
                :disabled="loading || !validForm || $permission('116')"
              >
              
                {{ $t("toSave") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate";

export default {
  name: "update-game",
  props: ["game"],
  data: () => ({
    dialog: false,
    loading: false,
    validForm: false,
    gameCategories: [],
    gameIdentifier: null,
    gameProvider: null,

    // models
    gameName: "",
    categoriesSelected: [],
    categoriesByGame: [],
    gameStatus: "",
    // rules
    requiredRules: [validate.required],
  }),

  computed: {
    gameStatusSelect () {
      return [
        {
          text: this.$t('active'),
          value: 1
        },
        {
          text: this.$t('inactive'),
          value: 0
        },
      ]
    },

    stringProviderId() {
      return this.$store.state.filters.autocompleteProvidersByOperator.stringId
    },

    srcImg() {
      return encodeURI(`https://cdn.softswiss.net/i/s2/${this.gameProvider}/${this.gameIdentifier}.png`.replace(/\s/g,''))
    }
  },

  watch: {
    dialog(val) {
      val && this.ListCategoriesByGame()
      val && this.getGameImg()
    },
  },

  methods: {
    getGameImg() {
      let gameIdentifierSplit = this.game.identifier.split(":")
      this.gameProvider = gameIdentifierSplit[0]
      this.gameIdentifier = gameIdentifierSplit[1]
    },

    handleGameCategories(gameData) {
      this.gameId = gameData.game.game_id
      this.gameName = gameData.game.name
      this.gameCategories = gameData.categories
      const categoriesWhereGameincluded = this.gameCategories.length > 0 ?
      this.gameCategories.map((category) => category.id) :
        false;
      let mapCategories = [];
      categoriesWhereGameincluded && this.categoriesByGame.forEach(function(category) {
        if (categoriesWhereGameincluded.includes(category.id)) {
          mapCategories.push(category.id)
        }
      })
      this.categoriesSelected = mapCategories
    },

    ListCategoriesByGame() {
      this.loading = true;
      const body = {
        game_id: this.game.id_game
      }
      this.$axios
      .post("colab/cassino/GamesAgregation/ListCategoriesByGame", this.$formdata(body))
      .then((response) => {
        this.categoriesByGame = response.data.dados
        this.getGameCategories()
      })
    },

    getGameCategories() {
      const body = {
        id: this.game.id_game
      }
      this.$axios.post("colab/cassino/GamesAgregation/getGame", this.$formdata(body))
      .then((response) => {
        this.handleGameCategories(response.data.dados)
      }).catch((error) => {
        console.log(error)
      })
      .finally(() => this.loading = false)
    },

    listProvidersByOperator() {
      this.$axios.get("colab/cassino/GamesAgregation/ListProviderbyOperator").then((response) => {
        console.log('listProvidersByOperator', response)
      })
    },

    bindGameToCategories() {
      this.loading = true
      const body = {
        id_game: this.game.id_game,
        status: this.game.status,
      }
      this.categoriesSelected.length > 0 ? this.categoriesSelected.forEach((item, i) => {
        body[`categories[${i}]`] = item;
      }) : body.categories = "";

      this.$axios.post("colab/cassino/GamesAgregation/bindGameToCategories", this.$formdata(body))
      .then((response) => {
        this.$store.commit("setFeedbackSnack", {
          msg: response.data.dados,
          color: "success",
        });
        this.$emit("refreshList")
        this.dialog = false

      }).catch((error) => {
        console.log(error)
      }).finally(() => this.loading = false)
    },

    closeDialog() {
      this.dialog = false
    },

    handleColorStatus(status) {
      if (status == 0) return "grey";
      if (status == 1) return "green";
    },
  },
};
</script>

<style>
.imgLoader {
  /* border: solid 1px rgb(87, 86, 86); */
  /* border-radius: 4px; */
  margin: 12px 0 36px 0;
  padding: 24px 0 24px 0;
  width: 322px;
  height: 172px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
